import React, { Component } from 'react';
import Navbar from '../../../_components/common/Navbar';
import { CommonBreadCrumb } from '../../../_components/common/CommonBreadCrumb';
import Settings from '../../../_components/common/SettingsHeader';
import TableNew from '../../../_components/common/TableNew';
import { tables } from './DemographicMastersTableData';
import ModalNew from '../../../_components/common/ModalNew';
import { connect } from 'react-redux';
import { demographicDataAction, addQualificationAction, updateOrDeleteDemographicDataAction, addDemographicDataAction } from '../../../_actions';
import SweetAlert from 'sweetalert2-react/lib/SweetAlert';


class DemographicMasters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            demographicData: '',
            modal: false,
            sortType: false,
            addNewQualificationState: false,
            addNewIndustryState: false,
            EditQualificationstate: false,
            EditIndustrystate: false,
            DeleteQualificationstate: false,
            DeleteIndustrystate: false,
            qualificationdetails: null,
            industryDetails: null,
        }
    }

    componentDidMount() {
        this.props.dispatch(demographicDataAction.getDemographicDataHandler());
    }

    toggleModal(showModal) {

        this.setState({
            modal: showModal,
        });


    }

    compareBy(key) {
        if (this.state.sortType == true) {
            return function (a, b) {
                if (a[key].toLowerCase() < b[key].toLowerCase()) return -1;
                if (a[key].toLowerCase() > b[key].toLowerCase()) return 1;
                return 0;
            };
        }

        if (this.state.sortType == false) {
            return function (a, b) {
                if (a[key].toLowerCase() > b[key].toLowerCase()) return -1;
                if (a[key].toLowerCase() < b[key].toLowerCase()) return 1;
                return 0;
            };
        }
    }

    sortBy(columnKey, type) {

        this.setState({ sortType: type })
        let arrayCopy = this.state.demographicData === '' ? this.props.demographicData : this.state.demographicData;
        arrayCopy.sort(this.compareBy(columnKey));
        this.setState({ demographicData: arrayCopy });
    }

    getDemographicType = (id) => {
        for (let i in this.props.demographicDataResponse) {

            for (let j in this.props.demographicDataResponse[i].demographics) {
                if (this.props.demographicDataResponse[i].demographics[j].id === id) {
                    return this.props.demographicDataResponse[i].id
                }
            }
        }
    }

    getDemographicTypeByName = (name) => {
        for (let i in this.props.demographicDataResponse) {

            if (this.props.demographicDataResponse[i].demographic_type_name_plurals === name) {
                return this.props.demographicDataResponse[i].id

            }
        }
    }

    toggleAddNewQualification(showModal) {

        this.setState({
            addNewQualificationState: showModal,
            addNewIndustryState: false,
            EditQualificationstate: false,
            EditIndustrystate: false,
            DeleteQualificationstate: false,
            DeleteIndustrystate: false,
        })
    }

    toggleEntireModal(showModal) {
        this.setState({
            addNewQualificationState: showModal,
            addNewIndustryState: showModal,
            EditQualificationstate: showModal,
            EditIndustrystate: showModal,
            DeleteQualificationstate: showModal,
            DeleteIndustrystate: showModal,
        })
    }

    addNewQualificationAction(data) {

        const fd = {
            "demographic_name": data.sellerData.qualification_name,
            "demographic_type": this.getDemographicTypeByName('QUALIFICATIONS')
        }

        this.props.dispatch(addDemographicDataAction.addDemographicDataHandler(fd))
    }

    editQualificationAction(data) {
        const fd = {
            "id": this.state.qualificationdetails.id,
            "demographic_name": data.sellerData.demographic_name,
            "demographic_type": this.getDemographicType(this.state.qualificationdetails.id)
        }

        this.props.dispatch(updateOrDeleteDemographicDataAction.updateOrDeleteDemographicDataHandler(fd, this.state.qualificationdetails.id, 'edit'));
    }



    addNewIndustryAction(data) {

        const fd = {
            "demographic_name": data.sellerData.industry_name,
            "demographic_type": this.getDemographicTypeByName('INDUSTRIES')
        }

        this.props.dispatch(addDemographicDataAction.addDemographicDataHandler(fd))

    }



    toggleQualificationsEditModal(showModal) {

        this.setState({
            addNewQualificationState: false,
            addNewIndustryState: false,
            EditQualificationstate: true,
            qualificationdetails: showModal,
            EditIndustrystate: false,
            DeleteQualificationstate: false,
            DeleteIndustrystate: false,
        })
    }

    toggleQualificationsDeleteModal(showModal) {

        this.setState({
            addNewQualificationState: false,
            addNewIndustryState: false,
            DeleteQualificationstate: true,
            qualificationdetails: showModal,
            EditQualificationstate: false,
            EditIndustrystate: false,
            DeleteIndustrystate: false,
        })
    }

    toggleAddNewIndustry(showModal) {
        this.setState({
            addNewIndustryState: showModal,
            addNewQualificationState: false,
            EditQualificationstate: false,
            EditIndustrystate: false,
            DeleteQualificationstate: false,
            DeleteIndustrystate: false,

        })
    }

    toggleIndustryEditModal(showModal) {

        this.setState({
            addNewQualificationState: false,
            addNewIndustryState: false,
            EditIndustrystate: true,
            industryDetails: showModal,
            EditQualificationstate: false,
            DeleteQualificationstate: false,
            DeleteIndustrystate: false,
        })
    }

    toggleIndustryDeleteModal(showModal) {

        this.setState({
            addNewQualificationState: false,
            addNewIndustryState: false,
            DeleteIndustrystate: true,
            industryDetails: showModal,
            EditQualificationstate: false,
            EditIndustrystate: false,
            DeleteQualificationstate: false,
        })
    }

    editIndustryAction(data) {
        const fd = {
            "id": this.state.industryDetails.id,
            "demographic_name": data.sellerData.demographic_name,
            "demographic_type": this.getDemographicType(this.state.industryDetails.id)
        }


        this.props.dispatch(updateOrDeleteDemographicDataAction.updateOrDeleteDemographicDataHandler(fd, this.state.industryDetails.id, 'edit'));

    }


    render() {

        const { demographicDataLoading, demographicDataResponse } = this.props;
        const filteredData = this.state.demographicData === '' ? demographicDataResponse : this.state.demographicData;



        let qualificationData;
        let industryData;
        for (let i in filteredData) {
            if (filteredData[i].demographic_type_name === "INDUSTRY") {
                industryData = filteredData[i].demographics;
            }
            if (filteredData[i].demographic_type_name === "QUALIFICATION") {

                qualificationData = filteredData[i].demographics;

            }
        }

        const qualificationFormData = [{
            key: 'qualification_name',
            type: 'text',
            value: '',
            valid: false,
            elementConfig: {
                name: 'qualification_name',
                label: 'Qualification',
                placeholder: 'Enter qualification'
            },
            validation: {
                required: true,
                message: "is required"
            },

        }]

        const editQualificationFormData = [{
            key: 'id',
            type: 'hidden',
            value: '',
            valid: true,
            elementConfig: {
                name: 'id',

            },
            validation: {
                required: false,
                message: "is required"
            },

        }, {
            key: 'qualification_name',
            type: 'plaintext',
            value: this.state.qualificationdetails ? this.state.qualificationdetails.demographic_name : '',
            valid: true,
            elementConfig: {
                name: 'qualification_name',
                label: 'Old Qualification',
            },
            validation: {
                required: false,
                message: "is required"
            },

        }, {
            key: 'demographic_name',
            type: 'text',
            value: '',
            valid: false,
            elementConfig: {
                name: 'qualification_name',
                label: 'New Qualification',
            },
            validation: {
                required: true,
                message: "is required"
            },

        },]

        const industryFormData = [{
            key: 'industry_name',
            type: 'text',
            value: '',
            valid: false,
            elementConfig: {
                name: 'industry_name',
                label: 'industry',
                placeholder: 'Enter industry'
            },
            validation: {
                required: true,
                message: "is required"
            },

        }]

        const editIndustryFormData = [{
            key: 'id',
            type: 'hidden',
            value: '',
            valid: true,
            elementConfig: {
                name: 'id',
                // label: 'id',
            },
            validation: {
                required: false,
                message: "is required"
            },

        }, {
            key: 'industry_name',
            type: 'plaintext',
            value: this.state.industryDetails ? this.state.industryDetails.demographic_name : '',
            valid: true,
            elementConfig: {
                name: 'industry_name',
                label: 'Old Industry',
            },
            validation: {
                required: false,
                message: "is required"
            },

        }, {
            key: 'demographic_name',
            type: 'text',
            value: '',
            valid: false,
            elementConfig: {
                name: 'industry_name',
                label: 'New Industry',
            },
            validation: {
                required: true,
                message: "is required"
            },

        },]


        return (
            < div >
                <Navbar />

                <div className="container custom-container my-5" >

                    <div>
                        <CommonBreadCrumb
                            data={[
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '',
                                    name: 'DEMOGRAPHIC MASTERS'
                                }
                            ]}
                        />
                    </div>
                    {
                        demographicDataResponse !== [] &&
                        <React.Fragment>
                            <div className="bg-green rounded-top position-relative animation-fade-in">
                                <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> QUALIFICATIONS</p>
                                {
                                    demographicDataLoading &&
                                    <i className="fas fa-spinner fa-spin text-white position-absolute spinner-position " ></i>
                                }
                            </div>
                            <Settings
                                buttonData={[
                                    {
                                        id: 1,
                                        heading: "ADD A NEW QUALIFICATION",

                                        toggler: this.toggleAddNewQualification.bind(this),
                                        togglerModal: this.state.addNewQualificationState
                                    }
                                ]}
                                filter={false}
                                modal={this.toggleModal.bind(this)}
                                showModal={this.state.modal}
                            />

                            {

                                <TableNew
                                    data={qualificationData ? qualificationData : ''}
                                    columns={tables.Qualifications}
                                    showSlNo="true"
                                    sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                                    sortType={this.state.sortType}
                                    onClickEditorDeleteButton={this.toggleQualificationsEditModal.bind(this)}
                                    onClickRemoveorDeleteIcon={this.toggleQualificationsDeleteModal.bind(this)}
                                />

                            }
                            {
                                this.state.addNewQualificationState &&
                                <ModalNew
                                    modalName="addNewQualificationState"

                                    heading="ADD QUALIFICATION"
                                    showModal={this.state.addNewQualificationState}
                                    formData={qualificationFormData}
                                    action={this.addNewQualificationAction.bind(this)}
                                    toggleEntireModal={this.toggleEntireModal.bind(this)}
                                />
                            }
                            {
                                this.state.EditQualificationstate &&
                                <ModalNew
                                    modalName="EditQualificationstate"

                                    isReset={true}
                                    heading="EDIT QUALIFICATION"
                                    showModal={this.state.EditQualificationstate}
                                    formData={editQualificationFormData}
                                    action={this.editQualificationAction.bind(this)}
                                    toggleEntireModal={this.toggleEntireModal.bind(this)}
                                />
                            }
                            {
                                this.state.DeleteQualificationstate &&
                                <SweetAlert
                                    show={this.state.DeleteQualificationstate}
                                    title=''
                                    text={"Are you sure you want to delete qualification: " + this.state.qualificationdetails.demographic_name + "?"}
                                    type='warning'
                                    showCancelButton={true}
                                    confirmButtonColor='#3085d6'
                                    confirmButtonText='OK'
                                    onConfirm={() => {
                                        const fd = {
                                            "id": this.state.qualificationdetails.id,
                                            "demographic_name": this.state.qualificationdetails.demographic_name,
                                            "demographic_type": this.getDemographicType(this.state.qualificationdetails.id)
                                        }
                                        this.props.dispatch(updateOrDeleteDemographicDataAction.updateOrDeleteDemographicDataHandler(fd, this.state.qualificationdetails.id, 'delete'));
                                        this.setState({ DeleteQualificationstate: false })
                                    }
                                    }
                                />
                            }

                            <div className="mt-4 bg-green rounded-top position-relative animation-fade-in">
                                <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> INDUSTRIES</p>
                                {
                                    demographicDataLoading &&
                                    <i className="fas fa-spinner fa-spin text-white position-absolute spinner-position " ></i>
                                }
                            </div>
                            <Settings
                                buttonData={[
                                    {
                                        id: 1,
                                        heading: "ADD A NEW INDUSTRY",

                                        toggler: this.toggleAddNewIndustry.bind(this),
                                        togglerModal: this.state.addNewIndustryState
                                    }
                                ]}
                                filter={false}
                                modal={this.toggleModal.bind(this)}
                                showModal={this.state.modal}
                            />
                            {

                                <TableNew
                                    data={industryData ? industryData : ''}
                                    columns={tables.Industries}
                                    showSlNo="true"
                                    sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                                    sortType={this.state.sortType}
                                    onClickEditorDeleteButton={this.toggleIndustryEditModal.bind(this)}
                                    onClickRemoveorDeleteIcon={this.toggleIndustryDeleteModal.bind(this)}
                                />
                            }
                            {
                                this.state.addNewIndustryState &&
                                <ModalNew
                                    modalName="addNewIndustryState"

                                    heading="ADD INDUSTRY"
                                    showModal={this.state.addNewIndustryState}
                                    formData={industryFormData}
                                    action={this.addNewIndustryAction.bind(this)}
                                    toggleEntireModal={this.toggleEntireModal.bind(this)}
                                />
                            }

                            {
                                this.state.EditIndustrystate &&
                                <ModalNew
                                    modalName="EditIndustrystate"

                                    isReset={true}
                                    heading="EDIT INDUSTRY"
                                    showModal={this.state.EditIndustrystate}
                                    formData={editIndustryFormData}
                                    action={this.editIndustryAction.bind(this)}
                                    toggleEntireModal={this.toggleEntireModal.bind(this)}
                                />
                            }

                            {
                                this.state.DeleteIndustrystate &&
                                <SweetAlert
                                    show={this.state.DeleteIndustrystate}
                                    title=''
                                    text={"Are you sure you want to delete Industry: " + this.state.industryDetails.demographic_name + "?"}
                                    type='warning'
                                    showCancelButton={true}
                                    confirmButtonColor='#3085d6'
                                    confirmButtonText='OK'
                                    onConfirm={() => {
                                        const fd = {
                                            "id": this.state.industryDetails.id,
                                            "demographic_name": this.state.industryDetails.demographic_name,
                                            "demographic_type": this.getDemographicType(this.state.industryDetails.id)
                                        }


                                        this.props.dispatch(updateOrDeleteDemographicDataAction.updateOrDeleteDemographicDataHandler(fd, this.state.industryDetails.id, 'delete'));
                                        this.setState({ DeleteIndustrystate: false })
                                    }
                                    }
                                />
                            }
                        </React.Fragment>
                    }
                    {
                        demographicDataResponse === [] &&
                        <p className="h6 text-center">No Data found</p>

                    }

                </div>
            </div >
        )


    }
}

function mapStateToProps(state) {


    const { demographicDataLoading } = state.getDemographicData;
    const getDemographicDataError = state.getDemographicData.error;
    const demographicDataResponse = (!demographicDataLoading && !getDemographicDataError) ? state.getDemographicData.data.data.results : '';
    return {
        demographicDataLoading,
        demographicDataResponse,
    }
}


export default connect(mapStateToProps)(DemographicMasters);



// WEBPACK FOOTER //
// ./src/_pages/Admin/DemographicMasters/index.jsx